/**
 * @generated SignedSource<<66482ff8441fd4064db661dbecb77008>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SetContactPreferredLanguageDialog_contact$data = {
  readonly id: string;
  readonly preferredLanguage: string | null | undefined;
  readonly " $fragmentType": "SetContactPreferredLanguageDialog_contact";
};
export type SetContactPreferredLanguageDialog_contact$key = {
  readonly " $data"?: SetContactPreferredLanguageDialog_contact$data;
  readonly " $fragmentSpreads": FragmentRefs<"SetContactPreferredLanguageDialog_contact">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SetContactPreferredLanguageDialog_contact",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "preferredLanguage",
      "storageKey": null
    }
  ],
  "type": "Contact",
  "abstractKey": "__isContact"
};

(node as any).hash = "d5a6251d14d55bed90c5f8dc610671e9";

export default node;
